import { render, staticRenderFns } from "./tdata.vue?vue&type=template&id=4924690e&scoped=true&"
import script from "./tdata.vue?vue&type=script&lang=js&"
export * from "./tdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4924690e",
  null
  
)

export default component.exports